"use client";

import { useState } from "react";

export default function KYCVerificationStep() {
    const [checked, setChecked] = useState({
        terms: true,
        commission: false,
        refund: false,
    });

    const handleChange = (e) => {
        const { name, checked: value } = e.target;
        setChecked((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div className="mb-4">
            <h2 className="h4 fw-semibold text-dark mb-4">
                Verification
            </h2>

            <div className="bg-white shadow-sm border-0" style={{ borderRadius: "14px" }}>
                <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-4">
                        <span className="text-secondary me-2">
                            <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                            </svg>
                        </span>
                        <h5 className="mb-0 fw-semibold text-secondary">
                            Aadhar Details
                        </h5>
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-medium">
                            Aadhar Number <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                            <div className="">
                                <input
                                    type="text"
                                    placeholder="Enter Adhar number"
                                    className="form-control"
                                />
                            </div>
                            <div className="position-absolute" style={{ top: "0", right: "0" }}>
                                <button className="btn text-white shadow-none" style={{
                                    background: "rgba(251, 130, 10, 1)"
                                }}>Verify</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="agreement-container bg-white shadow-sm" style={{ borderRadius: "14px" }}>
                <h3 className="agreement-title px-4 pt-4">
                    <span className="icon">👤</span> Seller Agreement
                </h3>

                <div className="bg-white pb-2" style={{ borderRadius: "14px" }}>
                    <div className="p-4 agreement-box m-4 pb-4">
                        <label className="checkbox-row">
                            <input
                                type="checkbox"
                                name="terms"
                                checked={checked.terms}
                                onChange={handleChange}
                            />
                            <span>
                                I accept the{" "}
                                <a href="#" className="link">
                                    Seller Terms & Conditions
                                </a>
                            </span>
                        </label>

                        <label className="checkbox-row">
                            <input
                                type="checkbox"
                                name="commission"
                                checked={checked.commission}
                                onChange={handleChange}
                            />
                            <span>
                                I accept the{" "}
                                <a href="#" className="link">
                                    Commission Policy
                                </a>
                            </span>
                        </label>

                        <label className="checkbox-row">
                            <input
                                type="checkbox"
                                name="refund"
                                checked={checked.refund}
                                onChange={handleChange}
                            />
                            <span>
                                I accept the{" "}
                                <a href="#" className="link">
                                    Return & Refund Policy
                                </a>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}
